import * as TeamRegisterSelector from './team-register.selector';

const TeamRegisterSelectorsMerge = { ...TeamRegisterSelector };
export {TeamRegisterSelectorsMerge as TeamRegisterSelectors};
